import React from "react";
import { MobileStepper } from "@mui/material";
import PropTypes from "prop-types";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  stepper: {
    paddingTop: theme.spacing(9)
  },
  activeDot: {
    backgroundColor: theme.palette.secondary.main
  }
}));

export default function SlideOutStepper(props) {
  const classes = useStyles();
  return (
    <MobileStepper
      className={classes.stepper}
      variant="dots"
      steps={props.numSteps}
      position="static"
      activeStep={props.activeStep}
      classes={{ root: classes.root, dotActive: classes.activeDot }}
    />
  );
}

SlideOutStepper.propTypes = {
  activeStep: PropTypes.number,
  numSteps: PropTypes.number
};
